const faqs = Array.from(document.getElementsByClassName("faqs__accordion-item"));



if(faqs?.length > 0) {
    for(let i = 0; i < faqs.length; i++) {
        faqs[i].addEventListener('click', openFaq, false);
    }    
}

function openFaq() {
    if(this.classList.contains('open')) {
        faqs.forEach(div => {
            div.classList?.remove('open')
        });
    } else {
        faqs.forEach(div => {
            div.classList?.remove('open')
        });
        this.classList?.add('open')
    }    
}
